import React from 'react'
import cx from 'classnames'
import { Field } from 'redux-form'
import { Input, Popup } from 'semantic-ui-react'

import { ComponentContainer } from '../../StyledComponents'
import { getValidationClasses } from 'loankeeper-common/helpers'
import { getSymbolsCountProps, getAsyncValidatingProps } from '../helpers'

const textNormalizer = (isPersonalNo) => (value, prevValue) => {
  if (isPersonalNo) {
    if (value) {
      if (!/^[0-9a-zA-Z\-_]+$/.test(value)) return prevValue
      return value
    }
    return ''
  }
  return value
}

const TextField = React.memo(
  ({
    input,
    className,
    flags,
    required,
    meta: { asyncValidating, valid, touched, error },
    type,
    maxLength,
    noErrorPopup,
    autoFocus,
    ...rest
  }) => {
    const popupClasses = cx(className, 'LKError', {
      'LKError--hidden': valid || !touched,
    })

    const inputClasess = getValidationClasses(error, required, touched)

    return !noErrorPopup ? (
      <Popup
        className={popupClasses}
        on="focus"
        popperDependencies={[error, touched, valid]}
        popperModifiers={{ preventOverflow: { enabled: false } }}
        trigger={
          <ComponentContainer className={className} input>
            <Input
              type={type || 'text'}
              {...input}
              {...getAsyncValidatingProps(asyncValidating)}
              {...getSymbolsCountProps(flags.symbolCounter, input.value)}
              maxLength={maxLength}
              className={inputClasess}
              autoFocus={autoFocus}
              {...rest}
            />
          </ComponentContainer>
        }
      >
        {error}
      </Popup>
    ) : (
      <ComponentContainer className={className} input>
        <Input
          type={type || 'text'}
          {...input}
          {...getAsyncValidatingProps(asyncValidating)}
          {...getSymbolsCountProps(flags.symbolCounter, input.value)}
          maxLength={maxLength}
          className={inputClasess}
          autoFocus={autoFocus}
          {...rest}
        />
      </ComponentContainer>
    )
  },
)

TextField.defaultProps = {
  flags: {},
  fluid: true,
  noErrorPopup: false,
  autoFocus: false,
}

const DecoratedField = (props) => (
  <Field component={TextField} normalize={textNormalizer(props.isPersonalNo)} {...props} />
)

export default DecoratedField
